/**
 * Return the input value if it's >=1, otherwise return the string "< 1"
 *
 * @param {Number} value numeric value to format
 * @returns {(String | Number)} formatted value
 */
export function formatPercentage(value) {
  return value < 1 ? "< 1" : Math.round(value).toString();
}
/**
 * Returns a properly formatted search route params Object or undefined for a GuiLink
 * This allows us to calculate values on the fly from the data object. Ie. 'present'
 * for a date up to today's date.
 *
 * @return {Object} | undefined
 */
export function constructSearch(search) {
  if (search.query.date_range != undefined) {
    // Allows us to use 'present' in our data to link to searches up to today's date
    search.query.date_range = search.query.date_range.replace(
      "present",
      new Date().getFullYear()
    );
  }
  return search;
}
